import { useState, useEffect } from "react";
import type { ShellUser } from "../../../api/types";
import { assignFeatureFlags } from "../../../config/feature-flags/config-cat-client";
import { getFeatureFlagsMMContract } from "../../../featureFlags";
import {
  getHiveAccount,
  type MmHiveAccountSchema,
} from "../requests/getHiveAccount";

export const useUpdateFeatureFlags = (user?: ShellUser | null) => {
  const [updatedFeatureFlag, setUpdatedFeatureFlag] = useState(false);

  useEffect(() => {
    if (user) {
      getHiveAccount()
        .then((h) => h)
        .catch(() => ({} as MmHiveAccountSchema))
        .then((hiveAccount) => {
          assignFeatureFlags(
            getFeatureFlagsMMContract(
              user,
              window.location,
              hiveAccount.projects?.find(
                (p) => p.project_id === hiveAccount.current_project
              )?.account_id || ""
            )
          ).then(() => setUpdatedFeatureFlag(true));
        });
    }
  }, [user]);

  return updatedFeatureFlag;
};
